"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUsername = void 0;
const EMAIL_REGEX = /^[^@]+@[^@]+\.[^@]+$/;
const PHONE_NUMBER_REGEX = /^([+])(\d){10,15}$/;
function validateUsername(username) {
    const isEmailValid = !!username.match(EMAIL_REGEX);
    const isPhoneNumberValid = !!username.match(PHONE_NUMBER_REGEX);
    let isUsername = true;
    if (isEmailValid || isPhoneNumberValid) {
        isUsername = false;
    }
    return { isUsername, isEmailValid, isPhoneNumberValid };
}
exports.validateUsername = validateUsername;
//# sourceMappingURL=validateUsername.js.map